import React from "react";
import { WaveTopBottomLoading } from "react-loadingg";

const PageLoading = () => {
  return <WaveTopBottomLoading size={"large"} color="#0d47a1" />;
};

export default PageLoading;
